module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_agder_neg.6c11b2a3.png";